/**
 * @desc 根据ID重试爬虫
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crawler/retryCrawler/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
